import Assessment from './DenormalizedAssessment.svelte';
import AssessmentList from './AssessmentList.svelte';
import AssessmentType from './AssessmentType.svelte';
import AssessmentTypeList from './AssessmentTypeList.svelte';
import AssessmentTypePolicies from './AssessmentTypePolicies.svelte';
import Results from './DenormalizeResults.svelte';
import Scoping from './DenormalizedScope.svelte';
import Login from './Login/Login.svelte';
import RecommendationList from './RecommendationList.svelte';
import Review from './AssessmentReview.svelte';
import Report from './AssessmentReport.svelte';
import NotFound from './404.svelte';
import PositiveControlList from './PositiveControlList.svelte';
import ServiceRecommendationList from './ServiceRecommendationList.svelte';
import KeyRecommendationList from './KeyRecommendationList.svelte';
import AssessmentTypeTags from './AssessmentTypeTags.svelte';
import AssessmentTypeInfo from './Components/AssessmentType/AssessmentTypeInfo.svelte';
// import ThreatList from './ThreatMatrix/ThreatList.svelte';
// import Threat from './ThreatMatrix/Threat.svelte';

import LibraryList from './Components/Libraries/ORMLibraryList.svelte';
import LibraryEdit from './Components/Libraries/ORMLibraryEdit.svelte';
import LibraryItems from './Components/Libraries/ORMLibraryItems.svelte';
import LibraryModeration from './Components/Libraries/ModerationQueue.svelte';

import DashboardList from './Components/Dashboards/DashboardList.svelte';
import DashboardEdit from './Components/Dashboards/DashboardEdit.svelte';
import DashboardItems from './Components/Dashboards/DashboardItems.svelte';
import DashboardMappings from './Components/Dashboards/DashboardMappings.svelte';

import SVGList from './Components/SVG/SVGList.svelte';

import GraphicsList from './Components/ReportGraphics/GraphicsList.svelte';
import GraphicEditor from './Components/ReportGraphics/GraphicEditor.svelte';

import SlideEditor from './Components/Slide Editor/SlideEditor.svelte';

import TemplateList from './Components/Templates/TemplateList.svelte';
import TemplateDetail from './Components/Templates/TemplateDetail.svelte';

import ReportSections from './Components/Report/ReportSections.svelte';

import QuestionLibraryList from './Components/QuestionLibrary/QuestionLibraryList.svelte';
import QuestionLibraryDetails from './Components/QuestionLibrary/QuestionLibraryDetails.svelte';
import LibraryTags from './Components/QuestionLibrary/LibraryTags.svelte'

import FrameworkList from './Components/FrameworkReference/FrameworkList.svelte';
import FrameworkDetails from './Components/FrameworkReference/FrameworkDetails.svelte';
import FrameworkFields from './Components/FrameworkReference/FrameworkFields.svelte';

// import ArchiveView from './ArchiveViewer.svelte';

import ManageSync from './Components/OfflineSync/ManageSync.svelte';
import TemplateSlideList from './Components/Slide Editor/TemplateSlideList.svelte';
import TemplateSlideEditor from './Components/Slide Editor/TemplateSlideEditor.svelte';

import RAMList from './Components/RecurringAssessmentMapping/RAMList.svelte';
import RAMDetail from './Components/RecurringAssessmentMapping/RAMDetail.svelte';

const routes = {
    '/': AssessmentList,
    '/login': Login,
    '/assessmentTypes/': AssessmentTypeList,
    '/assessmentTypes/:id/': AssessmentType,
    '/assessmentTypes/:id/category/:category_id/subcategory/:subcategory_id/control/:control_id': AssessmentType,

    '/assessmentTypes/:id/libraryCategory/:library_category_id/:subcategory_id/:control_id': AssessmentType,

    '/assessmentTypes/:id/policies': AssessmentTypePolicies,
    '/assessmentTypes/:id/tags': AssessmentTypeTags,
    '/assessmentTypes/:id/info': AssessmentTypeInfo,
    '/assessmentTypes/:id/report': ReportSections,
    '/assessmentTypes/:id/report/:section_id': ReportSections,

    '/assessment/:id': Assessment,
    '/assessment/:id/scope': Scoping,
    '/assessment/:id/results': Results,
    '/assessment/:id/review': Review,
    '/assessment/:id/report': Report,
    '/assessment/:id/report/:section_id': Report,
    '/assessment/:id/report/ppt/:slide_no': Report,


    '/recommendations/': RecommendationList,
    '/positiveControls/': PositiveControlList,
    '/serviceRecommendations': ServiceRecommendationList,
    '/keyRecommendations': KeyRecommendationList,

    // '/threatMatrix/': ThreatList,
    // '/threatMatrix/:id': Threat,

    '/slideEditor/': SlideEditor,

    '/libraries/': LibraryList,
    '/library/edit/:id': LibraryEdit,
    '/library/:id': LibraryItems,
    '/library/:id/moderation': LibraryModeration,

    '/dashboards/': DashboardList,
    '/dashboard/edit/:id': DashboardEdit,
    '/dashboard/:id': DashboardItems,
    '/dashboard/mappings/:id': DashboardMappings,

    '/SVGList': SVGList,

    '/reportGraphic/': GraphicsList,
    '/reportGraphic/add': GraphicEditor,
    '/reportGraphic/edit/:id': GraphicEditor,

    '/templates': TemplateList,
    '/template/:id': TemplateDetail,

    '/questionLibrary': QuestionLibraryList,
    '/questionLibrary/Tags': LibraryTags,
    '/questionLibrary/:id': QuestionLibraryDetails,
    '/questionLibrary/:id/:control_id': QuestionLibraryDetails,

    '/frameworkReference': FrameworkList,
    '/frameworkReference/:id': FrameworkDetails,
    '/frameworkReference/fields/:id': FrameworkFields,

    '/templateSlides/': TemplateSlideList,
    '/templateSlides/:id': TemplateSlideEditor,

    '/recurringAssessmentMappings': RAMList,
    '/recurringAssessmentMappings/:id': RAMDetail,

    '/manageSync': ManageSync,

    //'/archiveView': ArchiveView,
    '*': NotFound
}

function isActive(url) {
    let hash = window.location.hash;

    return url == hash
}

export {routes, isActive};